import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_VERSION || 'sv1'}`
  : "http://localhost:4001/api/sv1"

const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.request.use(config => {
  config.headers["Authorization"] = `Bearer ${localStorage.getItem("accessToken")}`
  config.headers["auth-key"] = localStorage.getItem("session_id")
  return config
})

axiosApi.interceptors.response.use(
  response => response,
  async error => {
    if (error?.response?.status === 401) {
      console.warn("[Superadmin API 401]", error)
    }
    return Promise.reject(error)
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function cdnpost(data, setUploadProgress) {
  return axiosApi
    .post("https://cdn.catchysystem.com/upload.php", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: progressEvent => {
        const progress = (progressEvent.loaded / progressEvent.total) * 100
        setUploadProgress(progress)
      },
    })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
